if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this._pinchCleanup = null;
    }

    hide() {
      this.teardownPinchZoom();
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();

      this.setupPinchZoom(activeMedia);
    }

    teardownPinchZoom() {
      if (typeof this._pinchCleanup === 'function') {
        this._pinchCleanup();
        this._pinchCleanup = null;
      }
    }

    setupPinchZoom(activeMedia) {
      this.teardownPinchZoom();
      if (!activeMedia || activeMedia.tagName !== 'IMG') return;

      const img = activeMedia;
      const surface = this.querySelector('[role="document"]') || this;
      const state = {
        scale: 1,
        lastScale: 1,
        x: 0,
        y: 0,
        startDist: 0,
        panStartX: 0,
        panStartY: 0,
        lastTap: 0,
      };

      const apply = () => {
        const maxX = (img.clientWidth * (state.scale - 1)) / 2;
        const maxY = (img.clientHeight * (state.scale - 1)) / 2;
        state.x = Math.min(maxX, Math.max(-maxX, state.x));
        state.y = Math.min(maxY, Math.max(-maxY, state.y));
        img.style.transform = `translate3d(${state.x}px, ${state.y}px, 0) scale(${state.scale})`;
      };

      const reset = () => {
        state.scale = 1;
        state.lastScale = 1;
        state.x = 0;
        state.y = 0;
        img.style.transform = '';
      };

      const distance = (touches) =>
        Math.hypot(
          touches[0].clientX - touches[1].clientX,
          touches[0].clientY - touches[1].clientY
        );

      const onStart = (event) => {
        if (event.touches.length === 2) {
          state.startDist = distance(event.touches) || 1;
          state.lastScale = state.scale;
        } else if (event.touches.length === 1 && state.scale > 1) {
          state.panStartX = event.touches[0].clientX - state.x;
          state.panStartY = event.touches[0].clientY - state.y;
        }
      };

      const onMove = (event) => {
        if (event.touches.length === 2) {
          event.preventDefault();
          const dist = distance(event.touches);
          state.scale = Math.min(4, Math.max(1, state.lastScale * (dist / state.startDist)));
          apply();
        } else if (event.touches.length === 1 && state.scale > 1) {
          event.preventDefault();
          state.x = event.touches[0].clientX - state.panStartX;
          state.y = event.touches[0].clientY - state.panStartY;
          apply();
        }
      };

      const onEnd = (event) => {
        if (event.target.closest('.product-media-modal__toggle')) return;

        if (event.touches.length === 0) {
          const now = Date.now();
          if (now - state.lastTap < 280) {
            if (state.scale > 1) {
              reset();
            } else {
              state.scale = 2.4;
              state.lastScale = 2.4;
              apply();
            }
            state.lastTap = 0;
            return;
          }
          state.lastTap = now;
        }

        if (state.scale <= 1.02) {
          reset();
        } else {
          state.lastScale = state.scale;
          apply();
        }
      };

      img.style.touchAction = 'none';
      img.style.webkitUserSelect = 'none';
      img.style.userSelect = 'none';
      surface.addEventListener('touchstart', onStart, { passive: true });
      surface.addEventListener('touchmove', onMove, { passive: false });
      surface.addEventListener('touchend', onEnd);

      this._pinchCleanup = () => {
        surface.removeEventListener('touchstart', onStart);
        surface.removeEventListener('touchmove', onMove);
        surface.removeEventListener('touchend', onEnd);
        img.style.transform = '';
        img.style.touchAction = '';
      };
    }
  });
}
